/* ==========================================================================
   LAURUS — Reversible header behaviors
   ----------------------------------------------------------------------------
   1. Adds a "Shop Now" CTA button into the header actions (right side).
   2. Adds an `is-scrolled` class on the header section after scrolling
      past 8px so CSS can apply a slight shrink/shadow effect.
   To revert: delete this file and remove the <script> line in
   snippets/stylesheets.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function injectShopNow() {
    var actions = document.querySelector('header-component header-actions, header-component .header-actions, header-component [class*="header-actions"]');
    if (!actions) return;
    if (actions.querySelector('.lc-shop-now')) return; // avoid duplicate

    var a = document.createElement('a');
    a.className = 'lc-shop-now';
    a.href = '/collections/all';
    a.textContent = 'Shop Now';
    actions.appendChild(a);
  }

  function setupScrollShrink() {
    var section = document.querySelector('.shopify-section.header-section');
    if (!section) return;
    var lastState = false;
    var THRESHOLD = 8;
    function update() {
      var scrolled = window.scrollY > THRESHOLD;
      if (scrolled !== lastState) {
        section.classList.toggle('is-scrolled', scrolled);
        lastState = scrolled;
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function init() {
    // injectShopNow();
    setupScrollShrink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
